import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import SISUsuarioCliente from '@/services/SistemaDKP/SISUsuarioCliente.service';
import store from '@/store';

const slsRepresentanteService = new SLSRepresentanteService();
const slsClienteService = new SLSClienteService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const sisUsuarioCliente = new SISUsuarioCliente();

export default class InitialDataService {
  static getUserId() {
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));
      return userData.userData?.id || 'default';
    } catch (error) {
      console.error('Erro ao obter ID do usuário:', error);
      return 'default';
    }
  }

  static getSessionId() {
    try {
      return localStorage.getItem('sessionId') || null;
    } catch (error) {
      console.error('Erro ao obter ID da sessão:', error);
      return null;
    }
  }

  static generateSessionId() {
    const sessionId = Date.now().toString();
    localStorage.setItem('sessionId', sessionId);
    return sessionId;
  }

  static isValidCache(cacheData) {
    try {
      if (!cacheData || typeof cacheData !== 'object') return false;

      const currentSessionId = this.getSessionId();
      if (!currentSessionId || !cacheData.sessionId) return false;

      return cacheData.sessionId === currentSessionId;
    } catch (error) {
      console.error('Erro ao validar cache:', error);
      return false;
    }
  }

  static clearOldCaches() {
    try {
      const allKeys = Object.keys(localStorage);
      const infoPedidoKeys = allKeys.filter((key) => key.startsWith('infoPedidoForm_'));

      infoPedidoKeys.forEach((key) => {
        try {
          const data = JSON.parse(localStorage.getItem(key));
          if (!this.isValidCache(data)) {
            localStorage.removeItem(key);
            console.log(`Cache antigo removido: ${key}`);
          }
        } catch (error) {
          // Se não conseguir parsear, remove o cache corrompido
          localStorage.removeItem(key);
          console.log(`Cache corrompido removido: ${key}`);
        }
      });
    } catch (error) {
      console.error('Erro ao limpar caches antigos:', error);
    }
  }

  static async loadInitialData() {
    try {
      // Gerar novo sessionId para esta sessão
      this.generateSessionId();

      // Limpar caches de sessões antigas
      this.clearOldCaches();

      await store.dispatch('InfoPedido/resertInfoPedido');
      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
      const isRepresentante = perfilLogado && perfilLogado.perfil_acesso_nome === 'Representante';
      const isClienteFinal = perfilLogado && (perfilLogado.perfil_acesso_nome === 'ClienteFinal' || perfilLogado.perfil_acesso_nome === 'Representante' || perfilLogado.perfil_acesso_nome === 'Supervisor');

      // Se for Representante, carregar o representante associado ao usuário e fixá-lo
      if (isRepresentante) {
        const representanteData = await this.loadRepresentanteForRepresentantePerfil();
        if (representanteData) {
          localStorage.setItem('representanteData', JSON.stringify(representanteData));
          console.log('Dados do representante salvos no localStorage');
        }
      }

      if (isClienteFinal) {
        const clienteData = await this.loadClienteFinalData();
        if (clienteData) {
          localStorage.setItem('clienteData', JSON.stringify({
            cliente: clienteData.cliente,
            representante: clienteData.representante,
            detalhes: clienteData.clienteInfo,
          }));
        }
      }

      return true;
    } catch (error) {
      console.error('Erro ao carregar dados iniciais:', error);
      return false;
    }
  }

  static async loadClienteFinalData() {
    try {
      // 1. Buscar o cliente associado ao usuário logado
      await store.dispatch('SLSCliente/resertFilters');
      const clientes = await sisUsuarioCliente.listarClienteSelecionados({
        usuarioId: this.getUserId(),
      });

      if (!clientes || clientes.length === 0) {
        console.error('Nenhum cliente encontrado para o usuário com perfil ClienteFinal');
        return null;
      }

      // Pegar o primeiro cliente encontrado (geralmente só deve haver um)
      const cliente = clientes[0];
      console.log('Cliente encontrado:', cliente);

      // 2. Buscar o representante associado ao cliente
      const representante = await slsRepresentanteService.listarRepresentanteByClienteIdERP(cliente.clienteiderp);

      if (!representante) {
        console.error('Não foi possível encontrar representante para o cliente:', cliente.clienteiderp);
      } else {
        console.log('Representante encontrado:', representante);
      }

      // 3. Buscar informações detalhadas do cliente
      const clienteInfo = await slsClienteService.getInfoPedidoByClienteId(cliente.clienteiderp);

      if (!clienteInfo) {
        console.error('Não foi possível obter informações detalhadas do cliente');
        return null;
      }

      // 4. Montar o objeto completo com todos os dados
      const formData = {
        ...clienteInfo,
        cliente,
        representante: representante || {
          representanteid: '',
          representantenome: '',
        },
      };

      // Verificar se a tabela de preço principal do cliente está nas opções disponíveis
      if (clienteInfo.cliente && clienteInfo.cliente.tabelaprecoid
        && clienteInfo.optionsTabelaPrecoCliente && clienteInfo.optionsTabelaPrecoCliente.length > 0) {
        const tabelaPrecoPrincipal = clienteInfo.optionsTabelaPrecoCliente.find(
          (tabela) => tabela.tabelapreco_id === clienteInfo.cliente.tabelaprecoid,
        );

        if (tabelaPrecoPrincipal) {
          formData.tabelaPreco = {
            tabelapreco_id: tabelaPrecoPrincipal.tabelapreco_id,
            tabelapreco_descricao: tabelaPrecoPrincipal.tabelapreco_descricao,
          };
        }
      }

      // Definir os dados no store
      store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', formData);

      // Definir os campos como somente leitura
      store.commit('InfoPedido/SET_CLIENTE_READONLY', true);
      store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);

      // Definir representante selecionado (importante para outros componentes)
      if (representante) {
        store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representante);
        store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
          representanteid: representante.representanteid,
          representantenome: representante.representantenome,
        });
      }

      // Salvar no localStorage com sessionId
      const userId = this.getUserId();
      const sessionId = this.getSessionId();
      const cacheData = {
        ...formData,
        sessionId,
        timestamp: Date.now(),
      };
      localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(cacheData));

      return { cliente, representante, clienteInfo };
    } catch (error) {
      console.error('Erro ao carregar dados para perfil ClienteFinal:', error);
      return null;
    }
  }

  static async loadRepresentanteForRepresentantePerfil() {
    try {
      // Buscar o representante associado ao usuário logado
      const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();

      if (representantes && representantes.length > 0) {
        const firstRepresentante = representantes[0];

        // Setar o representante no formulário e desabilitar a edição
        store.commit('InfoPedido/SET_REPRESENTANTE_FORM', firstRepresentante);
        store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', firstRepresentante);
        store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
        store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
          representanteid: firstRepresentante.representanteid,
          representantenome: firstRepresentante.representantenome,
        });

        return firstRepresentante;
      }
      return null;
    } catch (error) {
      console.error('Erro ao carregar representante para perfil Representante:', error);
      return null;
    }
  }

  static async loadRepresentantes(isClienteFinal) {
    await store.dispatch('SLSRepresentante/resertFilters');
    const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();

    // Se for ClienteFinal, retornar lista completa para verificação
    if (isClienteFinal) {
      return representantes;
    }

    return representantes;
  }

  static async selectRepresentante(representante) {
    store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representante);
    store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representante);
    store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
      representanteid: representante.representanteid,
      representantenome: representante.representantenome,
    });

    return representante;
  }

  static async loadClientes(representanteId, isClienteFinal) {
    store.commit('SLSCliente/SET_FILTERS', {
      page: 1,
      perPage: isClienteFinal ? 100 : 1, // Se for ClienteFinal, buscar mais para contar
      representanteid: representanteId,
    });

    const clientes = await slsClienteService.listarClienteInfoPedido();

    // Se for ClienteFinal, retornar lista completa para verificação
    if (isClienteFinal) {
      return clientes;
    }

    return clientes;
  }

  static async loadClienteData(cliente) {
    try {
      const clienteDetalhado = await slsClienteService.getInfoPedidoByClienteId(cliente.clienteiderp);

      if (clienteDetalhado) {
        store.commit('InfoPedido/SET_CLIENTE_DATA', {
          clienteData: clienteDetalhado,
          enderecoEntrega: clienteDetalhado.enderecoEntrega,
          dataCapaPedido: {
            estabelecimentoid: clienteDetalhado.estabelecimento.estabelecimentoid,
            clientenomeabreviado: clienteDetalhado.cliente.clientenomeabreviado,
            naturezaoperacaoid: clienteDetalhado.cliente.naturezaoperacaoid,
            canal_venda_id: clienteDetalhado.cliente.canal_venda_id,
            clienteisentoie: clienteDetalhado.cliente.clienteisentoie,
            tabelaprecoid: clienteDetalhado.tabelaPreco.tabelapreco_id,
            condicaopagamentoid: clienteDetalhado.condicaoPagamento.condicaopagamentoid,
          },
        });

        const formInfoPedido = store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
        store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
          representante: formInfoPedido.representante,
          ...clienteDetalhado,
        });

        store.commit('PicStore/SET_FILTERS', {
          clienteid: clienteDetalhado.cliente.clienteid,
          estabelecimentoid: clienteDetalhado.estabelecimento.estabelecimentoid,
          tabelaprecoId: clienteDetalhado.tabelaPreco.tabelapreco_id,
          condicaopagamentoid: clienteDetalhado.condicaoPagamento.condicaopagamentoid,
        });

        return clienteDetalhado;
      }
      return null;
    } catch (error) {
      console.error('Erro ao carregar dados do cliente:', error);
      return null;
    }
  }

  static async loadFirstRepresentante() {
    // Resetar filtros e carregar representantes
    await store.dispatch('SLSRepresentante/resertFilters');
    const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();

    if (representantes && representantes.length > 0) {
      const firstRepresentante = representantes[0];

      // Atualizar os dados do representante no store
      store.commit('InfoPedido/SET_REPRESENTANTE_FORM', firstRepresentante);
      store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', firstRepresentante);
      store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
        representanteid: firstRepresentante.representanteid,
        representantenome: firstRepresentante.representantenome,
      });

      return firstRepresentante;
    }
    return null;
  }

  static async loadFirstCliente() {
    // Buscar o representante atual
    const { representante } = store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
    if (!representante || !representante.representanteid) return null;

    // Definir filtros para buscar clientes associados ao representante
    store.commit('SLSCliente/SET_FILTERS', {
      page: 1,
      perPage: 1,
      representanteid: representante.representanteid,
    });

    // Buscar clientes
    const clientes = await slsClienteService.listarClienteInfoPedido();

    if (clientes && clientes.length > 0) {
      const firstCliente = clientes[0];

      // Buscar informações detalhadas do cliente
      const clienteDetalhado = await slsClienteService.getInfoPedidoByClienteId(firstCliente.clienteiderp);

      if (clienteDetalhado) {
        // Atualizar os dados do cliente no store
        store.commit('InfoPedido/SET_CLIENTE_DATA', {
          clienteData: clienteDetalhado,
          enderecoEntrega: clienteDetalhado.enderecoEntrega,
          dataCapaPedido: {
            estabelecimentoid: clienteDetalhado.estabelecimento.estabelecimentoid,
            clientenomeabreviado: clienteDetalhado.cliente.clientenomeabreviado,
            naturezaoperacaoid: clienteDetalhado.cliente.naturezaoperacaoid,
            canal_venda_id: clienteDetalhado.cliente.canal_venda_id,
            clienteisentoie: clienteDetalhado.cliente.clienteisentoie,
            tabelaprecoid: clienteDetalhado.tabelaPreco.tabelapreco_id,
            condicaopagamentoid: clienteDetalhado.condicaoPagamento.condicaopagamentoid,
          },
        });

        // Atualizar o formulário com os dados do cliente mantendo o representante atual
        const formInfoPedido = store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
        store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
          representante: formInfoPedido.representante,
          ...clienteDetalhado,
        });

        // Configurar filtros para PIC (promoções)
        store.commit('PicStore/SET_FILTERS', {
          clienteid: clienteDetalhado.cliente.clienteid,
          estabelecimentoid: clienteDetalhado.estabelecimento.estabelecimentoid,
          tabelaprecoId: clienteDetalhado.tabelaPreco.tabelapreco_id,
          condicaopagamentoid: clienteDetalhado.condicaoPagamento.condicaopagamentoid,
        });

        return clienteDetalhado;
      }
    }
    return null;
  }

  static async loadCondPagamento() {
    // Buscar o representante atual
    const { representante } = store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
    if (!representante || !representante.representanteid) return null;

    // Buscar condições de pagamento associadas ao representante
    const condicoesPagamento = await slsCondicaoPagamentoService.GetCondPagtoByRepresentanteId(representante.representanteid);

    if (condicoesPagamento && condicoesPagamento.length > 0) {
      const firstCondPagto = {
        condicaopagamentoid: condicoesPagamento[0].condicaopagamentoid,
        condicaopagamentodescricao: condicoesPagamento[0].condicaopagamento.condicaopagamentodescricao,
      };

      // Atualizar as condições de pagamento no store
      store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', condicoesPagamento);
      store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', firstCondPagto);
      store.commit('SLSCondicaoPagamento/SET_COND_PAGTOS', condicoesPagamento);

      return firstCondPagto;
    }
    return null;
  }
}
